export const Sides = {
    Right: "Right",
    Left: "Left",
    Back: "Back",
    Front: "Front",
    Top: "Top",
    Bottom: "Bottom",
};

export type faceLabel = "front" | "back" | "left" | "right" | "top" | "bottom";

export type ChoiceType = "Node" | "Hole" | "Plane";

interface ChoiceOptions {
    choices: ChoiceType[];
}

export const myChoices: ChoiceOptions = {
    choices: ["Node", "Hole", "Plane"],
};

export enum Choices {
    Node = "Node",
    Hole = "Hole",
    Plane = "Plane",
}

export const faceDetails: { [key in faceLabel]: ChoiceType } = {
    front: "Plane",
    back: "Plane",
    left: "Plane",
    right: "Plane",
    top: "Plane",
    bottom: "Plane",
};

export enum ErrorMessage {
    UnknownShapeType = "Unknown Shape Type",
}
